module.exports = __webpack_public_path__ + "static/media/mobile-app-development-img.7a94720a.png";